import React, { useState, useRef, useEffect, useContext } from "react";
import Header from "../../components/header";
import { useNavigate } from "react-router-dom";
import { API, baseURL } from "../../services/api";
import axios from "axios";
import AuthContext from "../../components/shared/AuthContext";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import OrgContext from "../../organisation/OrgContext";
import Select from "react-select";

const EditItems = () => {
  const [t, i18n] = useTranslation();
  const { user, logout } = useContext(AuthContext);
  const [isMarchandise, setIsMarchandise] = useState(true);
  const [isService, setIsService] = useState(false);

  let allRequiredInputsAreValid = true;
  const navigate = useNavigate();

  const typeIsMarchandise = useRef();
  const typeIsService = useRef();
  const { organisation, changeOrg } = useContext(OrgContext);

  const nameInputRef = useRef();

  const buyPriceInputRef = useRef("");
  const buyPriceAccountInputRef = useRef("");
  const SalesAccountDescription = useRef("");
  const qtyInput = useRef();

  const costPriceInputRef = useRef("");
  const costPriceAccountInputRef = useRef("");
  const purchaseAccountDescription = useRef("");

  const [isNotValid, setIsNotValid] = useState("");
  const [typeChecked, setTypeChecked] = useState(true);
  const [units, setUnits] = useState([]);
  const [salesAccounts, setSalesAccounts] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [taxes, setTaxes] = useState([]);
  const [selectedTaxeVente, setSelectedTaxeVente] = useState(null);
  const [selectedTaxeAchat, setSelectedTaxeAchat] = useState("");
  const [selectedPurchaseAccount, setSelectedPurchaseAccount] = useState([]);
  const [selectedSalesAccount, setSelectedSalesAccount] = useState([]);

  const [productName, setProductName] = useState("");
  const [getUnit, setUnit] = useState();
  const [buyPrice, setBuyPrice] = useState();
  const [buyAccount, setBuyAccount] = useState();
  const [salesAccountDescription, setSalesAccountDescription] = useState();

  const [purchasePrice, setPurchasePrice] = useState();
  const [purchaseAccount, setPurchaseAccount] = useState();
  const [purchaseAccountInfoDescription, setPurchaseAccountInfoDescription] =
    useState();
  const handleUniteChange = (e) => setSelectedUnit(e.target.value);

  const [taxeAchat, setTaxeAchat] = useState([]);
  const [taxeVente, setTaxeVente] = useState([]);

  const [article, setArticle] = useState(null);
  const [qty, setQty] = useState(null);

  const [isSubmit, setIsSubmit] = useState(false);
  const [loaded, setLoaded] = useState(false);

  /////////////////
  const [prixInitial, setPrixInitial] = useState(0.0);
  const { id } = useParams();
  useEffect(() => {
    getUnits();
    getSalesAccount();
    getPurchaseAccount();
    getTaxes();
  }, []);

  const getProduct = async (txs) => {
    setLoaded(false);

    await axios
      .get(baseURL + `/product/get/${id}`)
      .then((response) => {
        let item = response.data.data[0];
        console.log(item);
        if (item) {
          setArticle(item);
          if (item.type === "Services") {
            setTypeChecked(false);
            setIsService(true);
            setIsMarchandise(false);
          } else {
            setIsService(false);
            setIsMarchandise(true);
          }
          setProductName(item.name);
          setSelectedUnit(item.unit_id);
          setBuyPrice(item.sellingPrice);
          setBuyAccount(item.salesAccount_id);
          setSalesAccountDescription(item.sellingInfosDescription);

          setPurchasePrice(item.costPrice);
          setPurchaseAccount(item.purchaseAccount_id);
          setPrixInitial(item.prix_initial);
          setPurchaseAccountInfoDescription(item.purchaseInfosDescription);
          console.log(item?.qty);
          setQty(item?.qty);
          setSelectedTaxeVente({
            value: item.taxe_vente.id,
            label: item.taxe_vente.name,
          });
          setSelectedTaxeAchat({
            value: item.taxe_achat.id,
            label: item.taxe_achat.name,
          });
          setDepotQuantities(
            item.depot.reduce((acc, depo) => {
              acc[depo.depot_id] = depo.quantity || 0; // Initialize with 0 if quantity is undefined
              return acc;
            }, {})
          );
          setUnit(item.unit_id);
          setLoaded(true);
        }
      })
      .catch((error) => console.log("error while retrieving units : " + error));
  };
  const getUnits = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/units")
      .then((response) => {
        setUnits(response.data.data);
      })
      .catch((error) => console.log("error while retrieving units : " + error));
  };

  const getSalesAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/salesaccounts")
      .then((response) => {
        setSalesAccounts(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving setSalesAccounts : " + error)
      );
  };

  const getPurchaseAccount = async () => {
    // We run axios, a promise is returned
    await axios
      .get(baseURL + "/purshaseaccounts")
      .then((response) => {
        setPurchaseAccounts(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error)
      );
  };

  const getTaxes = async () => {
    setLoaded(false);

    await axios
      .get(baseURL + "/taxes")
      .then((response) => {
        setTaxes(response.data.data);
        setTaxeAchat(
          response.data.data.filter((taxe) => taxe.tax_type === "fournisseur")
        );
        setTaxeVente(
          response.data.data.filter((taxe) => taxe.tax_type === "client")
        );

        console.log(selectedTaxeVente);
        getProduct(response.data.data);
      })
      .catch((error) =>
        console.log("error while retrieving purshaseaccounts : " + error)
      );
  };

  const transformArray = (elt) => {
    let array = [];
    for (let i = 0; i < elt.length; i++) {
      let obj = { value: elt[i].id, label: elt[i].name + " - " + elt[i].code };
      array.push(obj);
    }
    return array;
  };

  const getSelectedType = () => {
    if (typeIsMarchandise.current.checked) {
      return "Marchandise";
    } else if (typeIsService.current.checked) {
      return "Services";
    }
  };
  const isInvalidDomElement = (elementId) => {
    const nomInput = document.getElementById(elementId);
    nomInput.classList.add("is-invalid");
  };
  const isaValidDomElement = (elementId) => {
    const nomInput = document.getElementById(elementId);
    nomInput.classList.remove("is-invalid");
    nomInput.classList.add("is-valid");
  };

  const checkRequiredInputs = () => {
    allRequiredInputsAreValid = true;
    if (nameInputRef.current.value.length <= 0) {
      isInvalidDomElement("nomInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("nomInput");
    }
    if (buyPriceInputRef.current.value.length <= 0) {
      isInvalidDomElement("buyPriceInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("buyPriceInput");
    }
    if (buyPriceAccountInputRef.current.value == 0) {
      isInvalidDomElement("buyPriceAccountInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("buyPriceAccountInput");
    }
    if (costPriceInputRef.current.value.length <= 0) {
      isInvalidDomElement("costPriceInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("costPriceInput");
    }
    if (costPriceAccountInputRef.current.value == 0) {
      isInvalidDomElement("costPriceAccountInput");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("costPriceAccountInput");
    }
    if (prixInitial < 0) {
      isInvalidDomElement("prixInitial");
      allRequiredInputsAreValid = false;
    } else {
      isaValidDomElement("prixInitial");
    }
    return allRequiredInputsAreValid;
  };
  const Edit = () => {
    if (checkRequiredInputs()) {
      const formData = new FormData(); // Utiliser FormData pour inclure l'image

      formData.append("type", getSelectedType());
      formData.append("name", nameInputRef.current.value);
      formData.append("unit_id", selectedUnit === null ? 14 : selectedUnit);
      formData.append("sellingPrice", buyPriceInputRef.current.value);
      formData.append("salesAccount_id", buyAccount);
      formData.append("sellingInfosDescription", SalesAccountDescription.current.value);
      formData.append("costPrice", costPriceInputRef.current.value);
      formData.append("purchaseInfosDescription", purchaseAccountDescription.current.value);
      formData.append("user_id", user.id);
      formData.append("productId", id);
      formData.append("qty", Number(qty).toFixed(2));
      formData.append("organization_id", organisation.id);
      formData.append("purchaseAccount_id", purchaseAccount);
      formData.append("taxevente", selectedTaxeVente?.value);
      formData.append("taxeachat", selectedTaxeAchat?.value);
      formData.append("prixInitial", Number(prixInitial).toFixed(2));

      
        formData.append("productImage", productImagee); // Ajouter l'image si elle est sélectionnée
      

      editProduct(formData);
    }
  };
  const editProduct = async (formData) => {
    setIsSubmit(true);
    API.patch("/product/edit", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Indiquer que le contenu est un formulaire multipart
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then((res) => {
        setIsSubmit(false);
        Swal.fire(t("Le produit a été modifié avec succès"), t(""), "success");
        navigate("/items");
      })
      .catch((error) => {
        setIsSubmit(false);
        console.log(error);
      });
  };

  const [depots, setDepots] = useState([]);
  const [depotQuantities, setDepotQuantities] = useState({});

  // Fetch depots and initialize depot quantities
  const fetchDepots = async () => {
    try {
      const response = await axios.get(`${baseURL}/depots/${organisation.id}`);
      setDepots(response.data);
      const initialQuantities = {};
      response.data.forEach((depot) => {
        initialQuantities[depot.id] = 0;
      });
      // setDepotQuantities(initialQuantities);
    } catch (error) {
      Swal.fire("Erreur", "Erreur lors de la récupération des dépôts", "error");
    }
  };

  // Handle changes in depot quantities
  const handleDepotQuantityChange = (depotId, value) => {
    const numericValue = isNaN(value) ? 0 : parseFloat(value);
    setDepotQuantities((prevQuantities) => ({
      ...prevQuantities,
      [depotId]: numericValue,
    }));
  };

  // Update total quantity based on depot quantities
  useEffect(() => {
    const totalQty = Object.values(depotQuantities).reduce(
      (sum, qty) => sum + qty,
      0
    );
    setQty(totalQty); // Update the total quantity state
  }, [depotQuantities]);

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        fetchDepots(),
        getUnits(),
        getSalesAccount(),
        getPurchaseAccount(),
        getTaxes(),
      ]);
    };
    fetchData();
  }, []);

  const [productImagee, setProductImagee] = useState(null);

  return (
    <>
      {/*<Header/>*/}
      <div className="main-container container-fluid">
        <div className="page-header">
          <h1 className="page-title">Modifier l'article</h1>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate("/items/list")}
                >
                  Liste des articles
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                modifier l'article
              </li>
            </ol>
          </div>
        </div>

        <div
          className="col-md-12"
          style={{ display: loaded ? "none" : "block" }}
        >
          <center>
            <div class="spinner-border text-primary me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </center>
        </div>

        <div className="row" style={{ display: !loaded ? "none" : "block" }}>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Information générale</div>
              </div>
              <div className="card-body">
                <p>
                  Sélectionnez si cet article est une marchandise physique ou un
                  service que vous pffrez
                </p>
                <div className="form-group mg-b-10">
                  <label
                    className="custom-switch ps-0"
                    hidden={isService && !isMarchandise}
                  >
                    <input
                      type="checkbox"
                      name="custom-switch-checkbox"
                      className="custom-switch-input"
                      checked={typeChecked}
                      onChange={(e) => {}}
                      onClick={() => {
                        setIsMarchandise(true);
                        setTypeChecked(true);
                        setIsService(false);
                      }}
                      ref={typeIsMarchandise}
                    />
                    <span className="custom-switch-indicator me-3"></span>
                    <span className="custom-switch-description mg-l-10">
                      Marchandises
                    </span>
                  </label>
                  <br />
                  <label className="custom-switch ps-0" hidden={isMarchandise}>
                    <input
                      type="checkbox"
                      name="custom-switch-checkbox"
                      className="custom-switch-input"
                      checked={!typeChecked}
                      onChange={(e) => {}}
                      onClick={() => {
                        setBuyPrice(0);
                        costPriceInputRef.current.value = 0;
                        setQty(1);

                        setIsMarchandise(false);
                        setTypeChecked(!typeChecked);
                        setIsService(true);
                      }}
                      ref={typeIsService}
                    />
                    <span className="custom-switch-indicator me-3"></span>
                    <span className="custom-switch-description mg-l-10">
                      Service
                    </span>
                  </label>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    Intitulé {isMarchandise ? "de l'article" : "du service"} *
                  </label>
                  <input
                    value={productName}
                    type="text"
                    className={`form-control ${isNotValid}`}
                    id="nomInput"
                    placeholder="Nom"
                    ref={nameInputRef}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                </div>
                <div className="form-group">
  <label htmlFor="productImagee">{t("Image de l'article")}</label>
  <input
    type="file"
    className="form-control"
    id="productImagee"
    accept="image/*"
    onChange={(e) => setProductImagee(e.target.files[0])} // Stocker l'image sélectionnée
  />
</div>

{/* Afficher l'image actuelle */}
{article?.path_image && (
  <div className="mb-4">
    <img
      src={`${baseURL.replace("/api", "")}/storage/${article.path_image}`}
      alt={article.name}
      style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
    />
  </div>
)}
                <div
                  className="form-group"
                  style={{
                    display: isService && !isMarchandise ? "none" : "block",
                  }}
                >
                  <label htmlFor="exampleInputEmail1">Unité</label>
                  <div className="input-group mb-3">
                    <select
                      className="form-select"
                      id="inputGroupSelect01"
                      value={selectedUnit}
                      onChange={handleUniteChange}
                    >
                      <option value="0">Séléctionnez une unité</option>
                      {units.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div
                  className="form-group"
                  hidden={isService && !isMarchandise}
                >
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    Quantité total*
                  </label>
                  <input
                    type="number"
                    min={0}
                    readOnly
                    className={`form-control ${isNotValid}`}
                    id="qtyInput"
                    placeholder="la quantité"
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    hidden={isService && !isMarchandise}
                  />
                  <label htmlFor="exampleInputEmail1" className="requiredElt">
                    {t("Prix initial")}*
                  </label>
                  <input
                    type="number"
                    className={`form-control ${isNotValid}`}
                    id="prixInitial"
                    placeholder="prix initial"
                    value={prixInitial}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value); // Convert string to number
                      if (!isNaN(value)) {
                        setPrixInitial(value);
                        console.log(prixInitial); // Apply toFixed only on valid number
                      }
                    }}
                    hidden={isService && !isMarchandise}
                  />
                </div>
                {/* Bloc Quantités par Dépôt */}
    <div className="form-group">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Quantités par dépôt</h3>
        </div>
        <div className="card-body">
          {depots.map((depot) => (
            <div key={depot.id} className="form-group">
              <label htmlFor={`depot-${depot.id}`}>
                Dépôt : {depot.name}
              </label>
              <input
                type="number"
                className="form-control"
                id={`depot-${depot.id}`}
                value={depotQuantities[depot.id]}
                onChange={(e) =>
                  handleDepotQuantityChange(
                    depot.id,
                    parseFloat(e.target.value) || 0
                  )
                }
              />
            </div>
          ))}
        </div>
        </div>
      </div>
              </div>
              </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Informations sur les ventes</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div
                      className="form-group"
                      hidden={isService && !isMarchandise}
                    >
                      <label htmlFor="exampleInputname" className="requiredElt">
                        Prix de vente*
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          {organisation?.currency?.code}
                        </span>
                        <input
                          type="number"
                          className={`form-control ${isNotValid}`}
                          aria-label="Amount (to the nearest dollar)"
                          value={buyPrice}
                          ref={buyPriceInputRef}
                          id="buyPriceInput"
                          onChange={(e) => setBuyPrice(e.target.value)}
                          hidden={isService && !isMarchandise}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      isService && !isMarchandise
                        ? "col-lg-12 col-md-12"
                        : "col-lg-6 col-md-12"
                    }
                  >
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputname1"
                        className={`requiredElt`}
                      >
                        Compte*
                      </label>
                      <select
                        className="form-select"
                        ref={buyPriceAccountInputRef}
                        id="buyPriceAccountInput"
                        onChange={(e) => setBuyAccount(e.target.value)}
                      >
                        {salesAccounts.map((account) => {
                          if (account.id === buyAccount) {
                            return (
                              <option value={account.id} selected>
                                {account.name + " - " + account.code}
                              </option>
                            );
                          }
                          return (
                            <option value={account.id}>
                              {account.name + " - " + account.code}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea
                    value={salesAccountDescription}
                    className="form-control"
                    rows="3"
                    defaultValue=""
                    ref={SalesAccountDescription}
                    onChange={(e) => setSalesAccountDescription(e.target.value)}
                  ></textarea>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Taxe</label>
                  <Select
                    id="inputGroupSelect01"
                    className={`form-element ${isNotValid}`}
                    options={transformArray(taxeVente)}
                    value={selectedTaxeVente}
                    onChange={(choice) => {
                      console.log(choice);
                      setSelectedTaxeVente(choice);
                      console.log(
                        "taxe de vente lier au compte: est : ",
                        selectedTaxeVente
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Informations sur les achats</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div
                    className="col-lg-6 col-md-12"
                    hidden={isService && !isMarchandise}
                  >
                    <div className="form-group">
                      <label htmlFor="exampleInputname" className="requiredElt">
                        Prix de revient*
                      </label>
                      <div className="input-group mb-3">
                        <span className="input-group-text">
                          {organisation?.currency?.code}
                        </span>
                        <input
                          value={purchasePrice}
                          type="number"
                          className={`form-control ${isNotValid}`}
                          aria-label="Amount (to the nearest dollar)"
                          ref={costPriceInputRef}
                          id="costPriceInput"
                          onChange={(e) => setPurchasePrice(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      isService && !isMarchandise
                        ? "col-lg-12 col-md-12"
                        : "col-lg-6 col-md-12"
                    }
                  >
                    <div className="form-group">
                      <label
                        htmlFor="exampleInputname1"
                        className={`requiredElt ${isNotValid}`}
                      >
                        Compte*
                      </label>
                      <select
                        className={`form-select ${isNotValid}`}
                        ref={costPriceAccountInputRef}
                        id="costPriceAccountInput"
                        onChange={(e) => setPurchaseAccount(e.target.value)}
                      >
                        {purchaseAccounts.map((account) => {
                          if (account.id === purchaseAccount) {
                            return (
                              <option value={account.id} selected>
                                {account.name + " - " + account.code}
                              </option>
                            );
                          }
                          return (
                            <option value={account.id}>
                              {account.name + " - " + account.code}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea
                    value={purchaseAccountInfoDescription}
                    className="form-control"
                    rows="3"
                    defaultValue=""
                    ref={purchaseAccountDescription}
                    onChange={(e) =>
                      setPurchaseAccountInfoDescription(e.target.value)
                    }
                  ></textarea>
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Taxe</label>
                  <Select
                    ref={costPriceAccountInputRef}
                    id="inputGroupSelect01"
                    className={`form-element ${isNotValid}`}
                    options={transformArray(taxeAchat)}
                    value={selectedTaxeAchat}
                    onChange={(choice) => {
                      setSelectedTaxeAchat(choice);
                    }}
                  />
                </div>
              </div>
              <div className="card-footer">
                <div className="row">
                  <div className="col-md-12">
                    <button
                      disabled={isSubmit}
                      type="button"
                      className="btn btn-primary"
                      onClick={Edit}
                    >
                      {isSubmit ? t("Loading ...") : t("Enregistrer")}
                    </button>
                    <a
                      onClick={() => {
                        navigate(-1);
                      }}
                      className="btn btn-default float-end"
                    >
                      Annuler
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditItems;
